import { render } from "./Tabs.vue?vue&type=template&id=29f44f14&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=29f44f14&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f44f14"]])

export default __exports__